// extracted by mini-css-extract-plugin
module.exports = {"root":"FormLayout_root__oQ_n5","rotation":"FormLayout_rotation__NQGJZ"};